import { Button, Input, message, Table } from "antd";
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { IAttachment } from "./interfaces";
import { Core } from "../../components/infrastructure/core";
import { enmEntityState } from "../../components/infrastructure/models";

export interface IAttachmentUploaderProps extends IBaseProps {
    onChange: (attachments: IAttachment[]) => void;
    attachments: IAttachment[];
    disabled?: boolean;
    whiteList: string;
}

export interface IAttachmentUploaderStates extends IBaseStates {
    attachments: IAttachment[];
}

export class AttachmentUploader extends BaseComponent<IAttachmentUploaderProps, IAttachmentUploaderStates>{
    inputFile?: Input | null;
    constructor(props: IAttachmentUploaderProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            attachments: props.attachments,
            windowSize: window.innerWidth <= 765 ? 1 : 2
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.setLoading(false);
    }
    browseFile = () => {
        this.inputFile?.input.click();
    }
    changeFile = async (event: any) => {
        let attachments = this.state.attachments;
        let fileStream = event.target.files.length ? event.target.files[0] : undefined;
        if (!fileStream || this.props.whiteList.split(',').indexOf(fileStream.type) === -1 || !fileStream.name || fileStream.name === '' || fileStream.name.split('.').length > 2 || fileStream.name.indexOf('\0') > -1) {
            message.error(`فایل انتخاب شده غیرمجاز است`);
            return false;
        }
        if ('image/png,image/jpg,image/jpeg,application/pdf'.split(',').indexOf(fileStream.type) > -1 && fileStream.size > 20971520) {
            message.error(`حداکثر حجم فایل 20 مگابایت باشد`);
            return false;
        }
        let id = Core.newId();
        attachments.push({
            RowGuid: id,
            State: enmEntityState.Added,
            File: fileStream,
            Title: fileStream.name,
            Description: '',
            Path: undefined
        } as any);
        this.props.onChange(attachments);
        this.setState({ attachments });
        this.inputFile?.setValue("");
    }
    virtualRender() {
        const columns = [
            {
                title: 'نام فایل',
                dataIndex: 'Title',
                key: 'Title',
                render: (text: any, attachment: IAttachment, _: number) => {
                    if (this.props.disabled) {
                        return <a href={attachment.Path} download={text}>{text}</a>;
                    }
                    return text;
                }
            },
            {
                title: 'توضیحات',
                dataIndex: 'Description',
                key: 'Description',
                render: (text: any, _: IAttachment, index: number) => {
                    return <Input
                        disabled={this.props.disabled}
                        value={text}
                        onChange={(e) => {
                            let { attachments } = this.state;
                            attachments[index].Description = e.target.value;
                            this.props.onChange(attachments);
                            this.setState({ attachments });
                        }}
                    />
                }
            },
            {
                title: '',
                dataIndex: 'Path',
                key: 'Path',
                width: 50,
                render: (_: any, record: IAttachment, __: number) => {
                    return (
                        <Button disabled={this.props.disabled} style={{ backgroundColor: 'transparent', border: 'none' }} icon={<DeleteOutlined />} size={"large"} title="حذف"
                            onClick={() => {
                                let { attachments } = this.state;
                                let index = attachments.indexOf(record);
                                attachments.splice(index, 1);
                                this.props.onChange(attachments);
                                this.setState({ attachments });
                            }}
                        />
                    );
                },
            }
        ];

        let { attachments } = this.state;
        return (
            <>
                {this.props.disabled ? <></> :
                    <div style={{ margin: "10px 0px" }}>
                        <Button onClick={this.browseFile} icon={<UploadOutlined style={{ verticalAlign: 'middle' }} />} style={{}} >
                            آپلود فایل
                        </Button>
                        <Input
                            type="file"
                            hidden
                            ref={node => this.inputFile = node}
                            onChange={this.changeFile}
                            accept={this.props.whiteList}
                        />
                    </div>
                }
                <Table rowKey={a => a.RowGuid} columns={columns} dataSource={attachments.map(a => a)} bordered />
            </>
        );
    }
}